<template>
	<b-card no-body>
		<b-card-header class="p-3 d-flex justify-content-between align-items-center">
			<h3 class="mb-0">Disbursement</h3>
			<!-- <div class="d-flex align-items-center text-primary">
        <p class="text-primary">View All</p>
      </div> -->
		</b-card-header>
		<div class="m-3" >
			<div class="mb-3">
				<span class="text-muted text-xs">Disbursement Status</span>
				<p class="text-warning font-weight-600">{{ _gHlp.getValue(activeCase,'disb_status_detail.name','-') }}</p>
			</div>
			<div class="mb-3">
				<span class="text-muted text-xs">Total Disbursed Amount</span>
				<p class="font-weight-600">RM {{ activeCase.disb_total_amt | moneyFormatter }}</p>
			</div>
			<div class="mb-3">
				<span class="text-muted text-xs">Remaining Amount</span>
				<p class="font-weight-600">RM {{ activeCase.disb_pending_amt | moneyFormatter }}</p>
			</div>
			<div class="mb-3">
				<span class="text-muted text-xs">Latest Disbursement Date</span>
				<p class="font-weight-600">{{ _gHlp.formatMomentDate(activeCase.disb_tat_date,'D MMM, YYYY') }}</p>
			</div>
		</div>
	</b-card>
</template>
<script>
import { mapState } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'
export default {
	computed: {
    ...mapState(useLoanCaseStore, ['activeCase']),
	}	
}
</script>